import { createContext, useContext, useState, useEffect, useCallback } from "react";

const LanguageContext = createContext();

const detectBrowserLanguage = () => {
  const nav = navigator.language || navigator.userLanguage || "en";
  return nav.startsWith("es") ? "es" : "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const stored = localStorage.getItem("vp_lang");
    return stored || detectBrowserLanguage();
  });

  useEffect(() => {
    localStorage.setItem("vp_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggleLang = useCallback(() => {
    setLang((prev) => (prev === "en" ? "es" : "en"));
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};

export default LanguageContext;
